import React from "react";
import DoctorList from "./DoctorList";
import "./Lab.css";
import { useSelector } from "react-redux";
import { selectUserId } from "../Login/loginSlice";
import { selectShowDoctorOrders } from "./labSlice";

const Lab = () => {
    const userId = useSelector(selectUserId);
    const showDoctorOrders = useSelector(selectShowDoctorOrders)
    return (
        <div className="lab-container">
            <div className="lab-header">
                
                <span className="lab-header-title" style={{textAlign: 'center', width: '100%'}}>
                    {showDoctorOrders ? 'Заказы': 'Врачи'}
                </span>
                
                {/* <button>+ Добавить</button> */}
            </div>
            <DoctorList userId={userId} />
        </div>
    );
};

export default Lab;
